export const ADMIN_ROUTE_PATHS = {
  admin: 'admin',
} as const;
